/**
 * Destek panelinde sayfaya ozel yardim + SSS (Yonlendirme Faz 3.4).
 *
 * Kullanim kilavuzu (features/usermanual) tek sayfa; her bolumun sabit bir
 * id'si var. Destek paneli bulunulan sayfaya gore kilavuzun ilgili bolumunu
 * "#bolum-id" ile acar. Liste kilavuzdaki id'lerle birebir eslesmeli.
 */

const normalizePath = (pathname: string) => pathname.replace(/^\/+|\/+$/g, '');

const segmentsMatch = (pattern: string, path: string) => {
    const expected = pattern.split('/');
    const actual = path.split('/');
    return (
        expected.length === actual.length &&
        expected.every((segment, index) => (segment.startsWith(':') ? actual[index] !== '' : segment === actual[index]))
    );
};

/** Sayfa adresi → kilavuz bolumu. Detay sayfalari genel sayfadan once gelir. */
export const MANUAL_SECTION_BY_PATH: Array<{ pattern: string; sectionId: string }> = [
    { pattern: 'home', sectionId: 'anasayfa' },
    { pattern: 'app-calender', sectionId: 'takvim' },
    { pattern: 'stand-participants-information-form', sectionId: 'bilgi-formu-form' },
    { pattern: 'stand-participants-information-form-list', sectionId: 'bilgi-formu-listesi' },
    { pattern: 'event', sectionId: 'etkinlik-listesi' },
    { pattern: 'event/:id', sectionId: 'etkinlik-detay' },
    { pattern: 'messages', sectionId: 'mesajlar' },
    { pattern: 'meetings/list', sectionId: 'toplantilarim' },
    { pattern: 'meetings/create', sectionId: 'toplanti-olustur' },
    { pattern: 'meetings/:id', sectionId: 'toplanti-detay' },
    { pattern: 'planned-company-meetings/planned', sectionId: 'gorusmelerim-planlanan' },
    { pattern: 'planned-company-meetings/realized', sectionId: 'gorusmelerim-gerceklesen' },
    { pattern: 'sessions', sectionId: 'b2b-oturumlari' },
    { pattern: 'announcements', sectionId: 'b2b-panel-duyurular' },
    { pattern: 'my-appointments', sectionId: 'b2b-randevularim' },
    { pattern: 'tables', sectionId: 'b2b-masa-randevusu' },
    { pattern: 'visitors', sectionId: 'ziyaretciler' },
    { pattern: 'company-list', sectionId: 'firma-listesi' },
    { pattern: 'company-add', sectionId: 'firma-ekle' },
    { pattern: 'company-detail/:id', sectionId: 'firma-detay' },
    { pattern: 'my-companies', sectionId: 'firmalarim' },
    { pattern: 'digital-cards-create', sectionId: 'dijitalkartvizit-ekle' },
    { pattern: 'digital-cards', sectionId: 'dijitalkartvizit-liste' },
    { pattern: 'meeting-requests', sectionId: 'gorusmetalepleri' },
    { pattern: 'catalogs', sectionId: 'kataloglar' },
    { pattern: 'products', sectionId: 'urunler' },
    { pattern: 'app-profile', sectionId: 'profil' },
    { pattern: 'settings', sectionId: 'ayarlar' },
];

/** Bulunulan sayfanin kilavuz bolumu; karsiligi yoksa `null`. */
export const findManualSection = (pathname: string): string | null => {
    const path = normalizePath(pathname);
    return MANUAL_SECTION_BY_PATH.find((entry) => segmentsMatch(entry.pattern, path))?.sectionId ?? null;
};

/** Kilavuz adresine bolum ekler: ".../usermanual" → ".../usermanual#toplantilarim". */
export const buildManualSectionUrl = (manualUrl: string, sectionId: string) =>
    `${manualUrl.split('#')[0]}#${encodeURIComponent(sectionId)}`;

/**
 * Sik sorulan sorular; her biri cevabin oldugu sayfaya gider ya da (yaka
 * karti gibi) isi dogrudan yapar. `routePath` kullanicinin rolune acik
 * degilse soru gosterilmez.
 */
export type SupportFaqItem = {
    questionKey: string;
    routePath: string;
    to?: string;
    action?: 'downloadBadge';
};

export const SUPPORT_FAQ: SupportFaqItem[] = [
    { questionKey: 'support.faq.findTable', to: '/my-appointments', routePath: 'my-appointments' },
    { questionKey: 'support.faq.sendRequest', to: '/company-list?filter=exhibitor', routePath: 'company-list' },
    { questionKey: 'support.faq.answerRequests', to: '/meeting-requests', routePath: 'meeting-requests' },
    { questionKey: 'support.faq.applySession', to: '/sessions', routePath: 'sessions' },
    { questionKey: 'support.faq.pickTable', to: '/tables', routePath: 'tables' },
    { questionKey: 'support.faq.badge', action: 'downloadBadge', routePath: 'home' },
    { questionKey: 'support.faq.card', to: '/digital-cards-create', routePath: 'digital-cards-create' },
];
